<template>
  <a-button :type="type" v-bind="$attrs" class="flex items-center">
    <template #icon>
      <slot name="icon" />
    </template>
    <slot />
  </a-button>
</template>

<script lang="ts">
export default {
  name: 'CButton',
}
</script>
<script lang="ts" setup>
defineProps({
  type: {
    type: String,
    default: 'default',
  },
})
</script>
<style scoped></style>
